module.exports = __webpack_public_path__ + "static/media/arrow_right_filled_blue.4e47f597.svg";